import script from "./UserLoginPasswordUpdateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLoginPasswordUpdateComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserLoginPasswordUpdateComponent.vue?vue&type=style&index=0&id=f6ab7b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ab7b34"]])

export default __exports__